<agr-print-page
  orientation="landscape"
  [footerText]="'report-title' | translate"
  [customizedLogoSrc]="customizedLogoSrc"
  [showAgrifirmLogo]="showAgrifirmLogo"
  [showFooter]="!isiOS"
  class="print-only"
  *ngIf="selectedReport$ | async as selectedReport"
>
  <div class="wrapper--spacing-horizontal" *ngIf="cycle$ | async as cycle">
    <div
      class="spacing--margin-horizontal spacing--margin-top"
      *ngIf="customer$ | async as customer"
    >
      <!-- PRINT_ONLY CUSTOMER INFO HEADER -->
      <div *ngIf="normalizedFlockDataObject$ | async as normalizedFlockDataObject">
        <div class="header-image"></div>
        <h1 class="align-center">{{ 'report-title' | translate }}</h1>
        <div class="row" [ngClass]="{ 'text-small': isiOS }">
          <!------------------------------------------------- L E F T   C O L U M N -->
          <div>
            <!------------------------------------------------------- GENERAL -->
            <div class="table">
              <div class="header">
                <span>{{ 'report-headers.general' | translate }}</span>
              </div>
              <div class="column_body">
                <ul class="list-unstyled">
                  <li>
                    <label>{{ 'report-columns.customer' | translate }}</label>
                    <span class="value">{{ customer.name }}</span>
                  </li>
                  <li>
                    <label>{{ 'report-columns.location' | translate }}</label>
                    <span class="value">{{ normalizedFlockDataObject.locationName }}</span>
                  </li>
                  <li>
                    <label>{{ 'report-columns.cycle-nr' | translate }}</label>
                    <span class="value">{{ normalizedFlockDataObject.cycleNumber }}</span>
                  </li>
                  <li>
                    <label *ngIf="selectedReport?.barnId; else pluralBarns">
                      {{ 'report-columns.barn' | translate }}
                    </label>
                    <ng-template #pluralBarns>
                      <label>{{ 'report-columns.barns' | translate }}</label>
                    </ng-template>
                    <span class="value">{{ getBarnNames(selectedReport) }}</span>
                  </li>
                  <li>
                    <label>{{ 'report-columns.breed' | translate }}</label>
                    <span class="value">{{ normalizedFlockDataObject.breeds }}</span>
                  </li>
                  <li>
                    <label>{{ 'report-columns.concept' | translate }}</label>
                    <span class="value">{{ cycle.concept.name }}</span>
                  </li>
                  <li>
                    <label>{{ 'report-columns.start-date' | translate }}</label>
                    <span class="value">{{ cycle.cycleDate | agrDate: 'shortDate' }}</span>
                  </li>
                </ul>
              </div>
            </div>
            <div class="spacer">&nbsp;</div>
            <!------------------------------------------------------- ARRIVAL -->
            <div class="table">
              <div class="header">{{ 'report-headers.day-old-chicks' | translate }}</div>
              <div class="column_body">
                <table class="table-m">
                  <thead>
                    <tr>
                      <th width="80px">{{ 'report-columns.date' | translate }}</th>
                      <th class="align-right">{{ 'report-columns.age' | translate }}</th>
                      <th class="align-right">{{ 'report-columns.amount' | translate }}</th>
                      <th class="align-right" *ngIf="showPrices$ | async">
                        {{ 'report-columns.price' | translate }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let dayOldChick of cycle.dayOldChicks">
                      <td>{{ dayOldChick.arrivalDate | agrDate: 'shortDate' }}</td>
                      <td class="align-right">
                        {{ getChickAge(dayOldChick) }}
                      </td>
                      <td class="align-right">
                        {{ getValue(dayOldChick.amountOfChicks) }}
                      </td>
                      <td class="align-right" *ngIf="showPrices$ | async">
                        {{ getChicksPrice(dayOldChick, cycle.currency) }}
                      </td>
                    </tr>
                    <tr class="total">
                      <td>{{ 'report-headers.total' | translate }}</td>
                      <td></td>
                      <td class="align-right">
                        {{ getValue(normalizedFlockDataObject.dayOldChicks) }}
                      </td>
                      <td class="align-right" *ngIf="showPrices$ | async">
                        {{
                          getCurrencyValue(
                            normalizedFlockDataObject.dayOldChicksPriceExclDiscounts,
                            cycle.currency
                          )
                        }}
                      </td>
                    </tr>
                    <ng-container
                      *ngFor="
                        let discount of getDiscounts(cycle, 'ArrivalCost', selectedReport?.barnId)
                      "
                    >
                      <tr class="discount" *ngIf="showPrices$ | async">
                        <td></td>
                        <td></td>
                        <td class="align-right">
                          {{
                            'report-columns.discountLabel-' + discount.label.toLowerCase()
                              | translate
                          }}
                        </td>
                        <td class="align-right">
                          {{ getCurrencyValue(discount.amount, cycle.currency) }}
                        </td>
                      </tr>
                    </ng-container>
                    <tr class="total_incl_discount" *ngIf="showPrices$ | async">
                      <td></td>
                      <td></td>
                      <td class="align-right">
                        {{ 'report-columns.total-incl-discount' | translate }}
                      </td>
                      <td class="align-right">
                        {{
                          getCurrencyValue(
                            normalizedFlockDataObject.dayOldChicksPrice,
                            cycle.currency
                          )
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="spacer">&nbsp;</div>
            <!----------------------------------------------------- DEPARTURE -->
            <div class="table">
              <div class="header">
                {{ 'report-headers.departures' | translate }}
              </div>
              <div class="column_body">
                <table class="table-m">
                  <thead>
                    <tr>
                      <th>{{ 'report-columns.date' | translate }}</th>
                      <th class="align-right">
                        {{ 'report-columns.age' | translate }}
                      </th>
                      <th class="align-right">
                        {{ 'report-columns.amount' | translate }}
                      </th>
                      <th class="align-right">
                        {{ 'report-columns.delivered' | translate }}
                      </th>
                      <th class="align-right">
                        {{ 'report-columns.weight' | translate }}
                      </th>
                      <th class="align-right">
                        {{ 'report-columns.paid' | translate }}
                      </th>
                      <th class="align-right">
                        {{ 'report-columns.rejected' | translate }}
                      </th>
                      <th class="align-right" *ngIf="showPrices$ | async">
                        {{ 'report-columns.price' | translate }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let departure of cycle.departures">
                      <td width="80px">{{ departure.departureDate | agrDate: 'shortDate' }}</td>
                      <td class="align-right">
                        {{ getDepartureChickAge(departure, cycle.dayOldChicks) }}
                      </td>
                      <td class="align-right">{{ getValue(departure.amountOfChicks) }}</td>
                      <td class="align-right">{{ getValue(departure.departureWeight) }}</td>
                      <td class="align-right">{{ getDepartureAverageChickWeight(departure) }}</td>
                      <td class="align-right">{{ getValue(departure.slaughterWeight) }}</td>
                      <td class="align-right">{{ getRejectPercentage(departure) }}</td>
                      <td class="align-right" *ngIf="showPrices$ | async">
                        {{ getCurrencyValue(departure.revenue, cycle.currency) }}
                      </td>
                    </tr>
                    <tr class="total">
                      <td>{{ 'report-headers.total' | translate }}</td>
                      <td class="align-right">
                        {{ getValue(normalizedFlockDataObject.weightedAverageAgeInDays, '1.0-0') }}
                      </td>
                      <td class="align-right">
                        {{ getValue(normalizedFlockDataObject.totalDeparture) }}
                      </td>
                      <td class="align-right">{{ getValue(getTotalDepartureWeight(cycle)) }}</td>
                      <td class="align-right">
                        {{ getValue(normalizedFlockDataObject.averageWeightInGram, '1.0-0') }}
                      </td>
                      <td class="align-right">{{ getValue(getTotalSlaughterWeight(cycle)) }}</td>
                      <td class="align-right">
                        {{ getValue(normalizedFlockDataObject.rejectionRate) }}
                      </td>
                      <td class="align-right" *ngIf="showPrices$ | async">
                        {{
                          getCurrencyValue(
                            normalizedFlockDataObject.revenueExclDiscounts,
                            cycle.currency
                          )
                        }}
                      </td>
                    </tr>
                    <ng-container
                      *ngFor="
                        let discount of getDiscounts(
                          cycle,
                          'DepartureRevenue',
                          selectedReport?.barnId
                        )
                      "
                    >
                      <tr class="discount" *ngIf="showPrices$ | async">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="align-right">
                          {{
                            'report-columns.discountLabel-' + discount.label.toLowerCase()
                              | translate
                          }}
                        </td>
                        <td class="align-right">
                          {{ getCurrencyValue(discount.amount, cycle.currency) }}
                        </td>
                      </tr>
                    </ng-container>
                    <tr class="total_incl_discount" *ngIf="showPrices$ | async">
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td class="align-right">
                        {{ 'report-columns.total-incl-discount' | translate }}
                      </td>
                      <td class="align-right">
                        {{ getCurrencyValue(normalizedFlockDataObject.revenue, cycle.currency) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="spacer">&nbsp;</div>
            <!------------------------------------------------- FEED OVERVIEW -->
            <div class="table break-inside-avoid">
              <div class="header">
                {{ 'report-headers.balance' | translate }}
              </div>
              <div class="column_body">
                <table class="table-m">
                  <thead>
                    <tr>
                      <th>{{ 'report-columns.feed-code' | translate }}</th>
                      <th>{{ 'report-columns.feed-name' | translate }}</th>
                      <th class="align-right">{{ 'report-columns.consumption' | translate }}</th>
                      <th class="align-right">
                        {{ 'report-columns.consumption-per-day-old-chick' | translate }}
                      </th>
                      <th class="align-right" *ngIf="showPrices$ | async">
                        {{ 'report-columns.price' | translate }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let balance of summarizedBalanceRows">
                      <td>{{ balance.productIdentifier }}</td>
                      <td>{{ balance.productTitle }}</td>
                      <td class="align-right">
                        {{ getValue(balance.totalConsumption) }}
                      </td>
                      <td class="align-right">
                        {{ getValue(balance.consumptionPerDayOldChick, '1.0-0') }}
                      </td>
                      <td class="align-right" *ngIf="showPrices$ | async">
                        {{ getCurrencyValue(balance.totalPrice, balance.currency) }}
                      </td>
                    </tr>
                    <tr class="total">
                      <td>{{ 'report-headers.total' | translate }}</td>
                      <td>&nbsp;</td>
                      <td class="align-right">
                        {{ getValue(normalizedFlockDataObject.feedBalance) }}
                      </td>
                      <td class="align-right">{{ totalConsumptionPerDayOldChick }}</td>
                      <td class="align-right" *ngIf="showPrices$ | async">
                        {{ getCurrencyValue(feedBalancePriceExclDiscounts, cycle.currency) }}
                      </td>
                    </tr>
                    <ng-container
                      *ngFor="
                        let discount of getDiscounts(cycle, 'FeedCost', selectedReport?.barnId)
                      "
                    >
                      <tr class="discount" *ngIf="showPrices$ | async">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td class="align-right">
                          {{
                            'report-columns.discountLabel-' + discount.label.toLowerCase()
                              | translate
                          }}
                        </td>
                        <td class="align-right">
                          {{ getCurrencyValue(discount.amount, cycle.currency) }}
                        </td>
                      </tr>
                    </ng-container>
                    <tr class="total_incl_discount" *ngIf="showPrices$ | async">
                      <td></td>
                      <td></td>
                      <td></td>
                      <td class="align-right">
                        {{ 'report-columns.total-incl-discount' | translate }}
                      </td>
                      <td class="align-right">
                        {{ getCurrencyValue(feedBalancePrice, cycle.currency) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="spacer">&nbsp;</div>
          </div>

          <!----------------------------------------------- R I G H T   C O L U M N -->
          <div>
            <div class="table">
              <div class="header">
                <span>{{ 'report-headers.key-figures' | translate }}</span>
              </div>
              <div class="column_body">
                <table class="table-m">
                  <thead>
                    <tr>
                      <th>{{ 'report-headers.technical' | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ 'report-columns.day-old-chicks' | translate }}</td>
                      <td class="value align-right">
                        {{
                          getValue(normalizedFlockDataObject.dayOldChicksPerSquareMeter, '1.2-2')
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ 'report-columns.drop-out-total' | translate }}</td>
                      <td class="value align-right">
                        {{ getValue(normalizedFlockDataObject.lossPercentage, '1.2-2') }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ 'report-columns.avg-age' | translate }}</td>
                      <td class="value align-right">
                        {{ getValue(normalizedFlockDataObject.weightedAverageAgeInDays, '1.2-2') }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ 'report-columns.avg-weight' | translate }}</td>
                      <td class="value align-right">
                        {{ getValue(normalizedFlockDataObject.averageWeightInGram, '1.0-0') }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ 'report-columns.deliveredkg-per-m2' | translate }}</td>
                      <td class="value align-right">
                        {{ getValue(normalizedFlockDataObject.deliveredKgPerSquareMeter, '1.2-2') }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ 'report-columns.growth' | translate }}</td>
                      <td class="value align-right">
                        {{
                          getValue(normalizedFlockDataObject.weightedAverageGrowthPerDay, '1.2-2')
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ 'report-columns.feed-conversion' | translate }}</td>
                      <td class="value align-right">
                        {{ getValue(normalizedFlockDataObject.feedConversion, '1.3-3') }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ 'report-columns.feed-conversion-1500' | translate }}</td>
                      <td class="value align-right">
                        {{ getValue(normalizedFlockDataObject.feedConversion1500, '1.3-3') }}
                      </td>
                    </tr>
                    <tr>
                      <td>{{ 'report-columns.replacement' | translate }}</td>
                      <td class="value align-right">
                        {{ getValue(normalizedFlockDataObject.replacementPercentage, '1.2-2') }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{ 'report-columns.avg-rejected' | translate }}
                      </td>
                      <td class="value align-right">
                        {{ getValue(normalizedFlockDataObject.rejectionRate, '1.2-2') }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{ 'report-columns.production-number' | translate }}
                      </td>
                      <td class="value align-right">
                        {{ getValue(normalizedFlockDataObject.productionNumber, '1.0-0') }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <hr />
                <table class="table-m" *ngIf="showFinancials$(normalizedFlockDataObject) | async">
                  <thead>
                    <tr>
                      <th>{{ 'report-headers.financial' | translate }}</th>
                      <th class="align-right">
                        <label>{{ 'report-columns.price' | translate }}</label>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {{ 'report-columns.price-per-delivered-chick' | translate }}
                      </td>
                      <td class="value align-right">
                        {{
                          getPricePerDeliveredChick(
                            normalizedFlockDataObject.dayOldChicksPrice,
                            normalizedFlockDataObject.dayOldChicks
                          )
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{ 'report-columns.feed-price-per-100' | translate }} ({{
                          cycle.currency | agrCurrencySymbol
                        }})
                      </td>
                      <td class="value align-right">
                        {{
                          getValue(normalizedFlockDataObject.feedConsumptionPricePer100Kg, '1.2-2')
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{ 'report-columns.feed-price-per-delivered-kg' | translate }}
                      </td>
                      <td class="value align-right">
                        {{
                          getValue(
                            getFeedPricePerDeliveredKg(
                              normalizedFlockDataObject.feedBalancePrice,
                              getTotalDepartureWeight(cycle)
                            )
                          )
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{ 'report-columns.yield-per-kg' | translate }} ({{
                          cycle.currency | agrCurrencySymbol
                        }})
                      </td>
                      <td class="value align-right">
                        {{ getValue(normalizedFlockDataObject.paidAmountPerKg, '1.4-4') }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{ 'report-columns.feed-profit' | translate }} ({{
                          cycle.currency | agrCurrencySymbol
                        }})
                      </td>
                      <td class="value align-right">
                        {{ getValue(normalizedFlockDataObject.nettoRevenue, '1.2-2') }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{ 'report-columns.feed-profit-per-day-old-chick' | translate }}
                      </td>
                      <td class="value align-right">
                        {{
                          getValue(normalizedFlockDataObject.nettoRevenuePerChick * 100, '1.2-2')
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{ 'report-columns.feed-profit-per-m2' | translate }} ({{
                          cycle.currency | agrCurrencySymbol
                        }})
                      </td>
                      <td class="value align-right">
                        {{
                          getValue(normalizedFlockDataObject.nettoRevenuePerSquareMeter, '1.2-2')
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{ 'report-columns.feed-profit-per-m2-per-day' | translate }}
                      </td>
                      <td class="value align-right">
                        {{
                          getValue(
                            normalizedFlockDataObject.nettoRevenuePerSquareMeterPerDay * 100,
                            '1.2-2'
                          )
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {{ 'report-columns.netto-profit-incl-other-costs' | translate }}
                        ({{ cycle.currency | agrCurrencySymbol }})
                      </td>
                      <td class="value align-right">
                        {{ getValue(normalizedFlockDataObject.nettoProfitInclOtherCosts, '1.2-2') }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</agr-print-page>
